const relativeUrlBase = 'https://elanco.local'
const excludedQueryParams = ['secret', 'slug']

export function getQueryStringFromPath(path: string): string {
	try {
		const queryParams = new URL(path, relativeUrlBase).searchParams

		excludedQueryParams.forEach((param) => {
			queryParams.delete(param)
		})

		const queryString = queryParams.toString()
		return queryString ? `?${queryString}` : ''
	} catch {
		return ''
	}
}

function shouldPreserveUrl(url: string): boolean {
	return ['mailto:', 'tel:', 'sms:', '#'].some((prefix) =>
		url.startsWith(prefix)
	)
}

function normalizeQueryString(queryString: string): string {
	return queryString.replace(/^[?&]+/, '')
}

export function appendQueryStringToUrl(
	url: string,
	queryString: string
): string {
	const queryParams = new URLSearchParams(normalizeQueryString(queryString))

	if (!url || shouldPreserveUrl(url) || queryParams.size === 0) return url

	if (!canParseUrl(url)) {
		return url
	}

	return serializeUrlWithQueryString(url, queryParams.toString())
}

function canParseUrl(url: string): boolean {
	try {
		return Boolean(new URL(url, relativeUrlBase))
	} catch {
		return false
	}
}

function serializeUrlWithQueryString(url: string, queryString: string): string {
	const hashIndex = url.indexOf('#')
	const urlBeforeHash = hashIndex === -1 ? url : url.slice(0, hashIndex)
	const hash = hashIndex === -1 ? '' : url.slice(hashIndex)
	const separator = getQueryStringSeparator(urlBeforeHash)

	return `${urlBeforeHash}${separator}${queryString}${hash}`
}

function getQueryStringSeparator(url: string): string {
	if (url.endsWith('?') || url.endsWith('&')) return ''

	return url.includes('?') ? '&' : '?'
}
